var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapforce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "MapForce",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 28.8c0 15.7-12.8 28.5-28.5 28.5S.3 44.5.3 28.8 13.1.3 28.8.3s28.5 12.8 28.5 28.5z",
    fill: "#f5a300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6 18.1c0-3.5-2.9-6.4-6.4-6.4-1.8 0-3.3.7-4.5 1.9l-5.9 5.9h-.1l-5.9-5.9c-1.1-1.1-2.7-1.9-4.5-1.9-3.5 0-6.4 2.8-6.4 6.4v21.4c0 1.6.6 3.2 1.9 4.5 2.5 2.5 6.5 2.5 9 0l3.3-3.2c.7-.7 1.6-1.2 2.7-1.2h.1c1.1 0 2 .4 2.7 1.2l3.3 3.2c2.5 2.5 6.5 2.5 9 0 1.2-1.2 1.9-2.9 1.9-4.5l-.2-21.4z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m36.7 15.4-7.9 7.9-7.8-7.9c-.7-.7-1.6-1.2-2.7-1.2-2 0-3.7 1.7-3.7 3.7 0 1.1.5 2 1.2 2.7L26.1 31c.7.7 1.6 1.2 2.7 1.2.9 0 1.8-.3 2.4-.9l.2-.2 10.3-10.3c.8-.8 1.3-1.7 1.3-2.8 0-2-1.7-3.7-3.7-3.7-1 0-2 .4-2.6 1.1z",
    fill: "#bb6925"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapforce);
export default __webpack_public_path__ + "static/media/mapforce.fa7ab27104b15d930972086d2d61255a.svg";
export { ForwardRef as ReactComponent };